import React from "react";
import CustomCarousel from "../Carousel";
import WorkSlide from "./WorkSlide";
import { workExperience } from "../../../constants/work-experience";
import { SECTIONS } from "../../../constants/sections";
import "./workexperience.css";
import { Cover } from "./Cover";

export default function WorkExperienceHtml({
  currentSection,
  themeKey,
  coverPath,
}) {
  const workSlides = [
    <Cover coverPath={coverPath} themeKey={themeKey} />,
    ...workExperience.map((content) => (
      <WorkSlide
        content={content}
        key={content.id}
        isInteractive={currentSection.name === SECTIONS.EXPERIENCE}
        themeKey={themeKey}
      />
    )),
  ];

  return (
    <CustomCarousel
      className={
        themeKey === "dark" ? "we-container dark-carousel" : "we-container"
      }
      isPaused={currentSection.name !== SECTIONS.EXPERIENCE}
      showArrows
      showDots
    >
      {workSlides}
    </CustomCarousel>
  );
}
